// Traduzioni. Ogni testo dell'app passa da qui: niente scritte fisse nel codice.
import it from './lingue/it.js';
import en from './lingue/en.js';

export const LINGUE = { it, en };
export const NOMI_LINGUE = { it: 'Italiano', en: 'English' };

let attuale = 'it';

export function scegliLingua(codice) {
  attuale = LINGUE[codice] ? codice : 'it';
  if (typeof document !== 'undefined') document.documentElement.lang = attuale;
  return attuale;
}

export function linguaDelTelefono(lingue = globalThis.navigator?.languages || []) {
  for (const l of lingue) {
    const c = String(l).slice(0, 2).toLowerCase();
    if (LINGUE[c]) return c;
  }
  return 'it';
}

export const lingua = () => attuale;

// t('agenda.titolo') · t('attesa.codice', { codice: 'AB12CD' }). Se manca una traduzione si usa l'italiano.
export function t(chiave, valori = {}) {
  const testo = LINGUE[attuale][chiave] ?? it[chiave] ?? chiave;
  return testo.replace(/\{(\w+)\}/g, (_, k) => (valori[k] ?? `{${k}}`));
}
